export const DeprecatedRoute = {
  DEPRECATEDLAYOUT: {
    path: '',
    name: 'deprecatedlayout'
  },
  CLEAR_WILL: {
    path: 'sign-up/free-will',
    name: 'deprecated-sign-up-clear-will'
  },
  CLEAR_WILL_FRENCH: {
    path: 'sign-up/free-will?lang=fr-qc',
    name: 'deprecated-sign-up-clear-will-french'
  },
  DEPRECATED_CLEAR_WILL: {
    path: 'deprecated/free-will',
    name: 'deprecated-clear-will'
  },
  DEPRECATED_CLEAR_WILL_FRENCH: {
    path: 'deprecated/free-will?lang=fr-qc',
    name: 'deprecated-clear-will-french'
  },
  MAKE_A_WILL: {
    path: 'sign-up/make-a-will',
    name: 'make-a-will'
  },
  MAKE_A_WILL_FRENCH: {
    path: 'sign-up/make-a-will?lang=fr-qc',
    name: 'make-a-will-french'
  }
};
